import './src/polyfill-keyboard-event';
import {
  RegisterShortcutHandlerOptions as _RegisterShortcutHandlerOptions,
  RegisterShortcutOptions as _RegisterShortcutOptions,
  ShortcutEvent as _ShortcutEvent,
  ShortcutHandler as _ShortcutHandler,
} from './src/types';

export type RegisterShortcutHandlerOptions = _RegisterShortcutHandlerOptions;
export type RegisterShortcutOptions = _RegisterShortcutOptions;
export type ShortcutEvent = _ShortcutEvent;
export type ShortcutHandler = _ShortcutHandler;
export {
  getKey,
  isArrow,
  isSubmitEvent,
  isForceSubmitEvent,
} from './src/keyboard';
export {
  registerShortcut,
  registerShortcutHandler,
  unregisterShortcut,
  unregisterShortcutHandler,
} from './src/shortcuts';
export { useShortcut, useShortcutHandler } from './src/hooks';
export { Key, Scope } from './src/types';
